import type { PlatformNotification, StudentAccount } from '../types/identity'

export const account: StudentAccount = {
  id: 'CAMP-8H2K41QD',
  username: 'amarachi',
  financialIdentifier: 'FIN-••••-4192',
  lifecycleStage: 'student',
  reputation: [
    {
      dimension: 'housing',
      label: 'Housing',
      score: 92,
      basis: '2 tenancies, rent paid on time, 1 review received',
    },
    {
      dimension: 'services',
      label: 'Marketplace',
      score: 88,
      basis: '4 completed orders, 1 open dispute raised',
    },
    {
      dimension: 'knowledge',
      label: 'Knowledge',
      score: 74,
      basis: '3 entitlements, 2 reviews written',
    },
    {
      dimension: 'community',
      label: 'Community',
      score: 81,
      basis: '2 organizations, 3 events attended, no reports upheld',
    },
  ],
  fullName: 'Amarachi Obi',
  initials: 'AO',
  email: 'amarachi.obi@campuzon.com',
  phone: '+234 806 555 0142',
  roles: ['student'],
  institutionId: 'inst-unilag',
  campusId: 'campus-akoka',
  academic: {
    faculty: 'Faculty of Engineering',
    department: 'Systems Engineering',
    programme: 'B.Sc. Systems Engineering',
    level: '300 Level',
    matricNumber: '210404021',
    status: 'Enrolled',
  },
  visibility: {
    academic: 'private',
    housing: 'private',
    roommate: 'connections',
    career: 'public',
    contact: 'private',
  },
}

export const notifications: PlatformNotification[] = [
  {
    id: 'ntf-1',
    category: 'safety',
    title: 'Campus alert — Akoka gate 2',
    detail: 'Power cable repair works. Use gate 1 until 6pm today.',
    time: '18 min ago',
    priority: 'emergency',
    read: false,
  },
  {
    id: 'ntf-2',
    category: 'academic',
    title: 'SYE 305 assignment due tomorrow',
    detail: 'Control systems problem set, 09:00.',
    time: '2 hours ago',
    priority: 'high',
    read: false,
  },
  {
    id: 'ntf-3',
    category: 'housing',
    title: 'Application moved to review',
    detail: 'Cedarwood Student Residence is reviewing your application.',
    time: '5 hours ago',
    priority: 'normal',
    read: false,
  },
  {
    id: 'ntf-4',
    category: 'payment',
    title: 'Rent instalment due in 9 days',
    detail: '₦185,000 second instalment for Room B-204.',
    time: 'Yesterday',
    priority: 'normal',
    read: true,
  },
  {
    id: 'ntf-5',
    category: 'career',
    title: 'Internship shortlist',
    detail: 'Paystack moved your application to interview stage.',
    time: '2 days ago',
    priority: 'normal',
    read: true,
  },
  {
    id: 'ntf-6',
    category: 'campus',
    title: 'Engineering Week opens Monday',
    detail: 'Five days of talks, competitions and career sessions.',
    time: '3 days ago',
    priority: 'normal',
    read: true,
  },
]
